import React, { Component } from "react";

import "./table.css";

import ConsultaTableLine from "./consulta-table-line";

import Table from "react-bootstrap/Table";
import ReactPaginate from "react-paginate";

const COLUNAS = ["PEDIDO ESSILOR", "PEDIDO ÓTICA", "DATA DO PEDIDO"];

class ConsultaTableHead extends Component {
  renderPaginacao() {
    const { paginaAtual, paginaTotal, onPageChange } = this.props;

    if (!paginaTotal || paginaTotal <= 1) return null;

    return (
      <div className="pagination-container">
        <ReactPaginate
          previousLabel={"Anterior"}
          nextLabel={"Próximo"}
          breakLabel={"..."}
          breakClassName={"break-me"}
          pageCount={paginaTotal}
          marginPagesDisplayed={2}
          pageRangeDisplayed={2}
          forcePage={Math.max(0, (paginaAtual || 1) - 1)}
          onPageChange={e => onPageChange(e.selected + 1)}
          containerClassName={"pagination"}
          subContainerClassName={"pages pagination"}
          activeClassName={"active"}
        />
      </div>
    );
  }

  render() {
    const { pedidos, paginaAtual, laboratorio } = this.props;

    return (
      <div>
        {this.renderPaginacao()}

        <Table className="consulta-table table text-center">
          <thead className="thead-dark">
            <tr>
              {COLUNAS.map((titulo, index) => (
                <th key={index} className="consulta-thead-th">
                  {titulo}
                </th>
              ))}
              <th className="consulta-thead-th"></th>
            </tr>
          </thead>

          {pedidos.map((item, index) => (
            <ConsultaTableLine key={item.id || index} item={item} index={index} laboratorio={laboratorio} pagina={paginaAtual} />
          ))}
        </Table>

        {this.renderPaginacao()}
      </div>
    );
  }
}

export default ConsultaTableHead;
